import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';

interface IProps {
    toastKey: string;
    content: React.ReactNode;
    snackbarRef: React.RefObject<HTMLDivElement>;
    className?: string;
}

const SwipeCloseSnackbar = ({ toastKey, content, snackbarRef, className }: IProps) => {
    const { closeSnackbar } = useSnackbar();

    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => closeSnackbar(toastKey),
        preventScrollOnSwipe: true,
        trackTouch: true,
    });

    useEffect(() => {
        if (snackbarRef.current) {
            swipeHandlers.ref(snackbarRef.current);
        }
        return () => {
            if (snackbarRef.current) {
                swipeHandlers.ref(null);
            }
        };
    }, [swipeHandlers]);

    return <span className={className}>{content}</span>;
};

export default SwipeCloseSnackbar;
